import Add from "@mui/icons-material/Add";
import Close from "@mui/icons-material/Close";
import Remove from "@mui/icons-material/Remove"; // GLOBAL CUSTOM COMPONENTS
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton"; // MUI ICON COMPONENTS
import Link from "next/link";
import React from "react";
import Image from "src/lib/components/salify-next-layout/default/components/Image";
import { Span } from "src/lib/components/salify-next-layout/default/components/Typography";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box"; // GLOBAL CUSTOM HOOK
import useCart from "src/lib/components/salify-next-layout/default/hooks/useCart"; // CUSTOM UTILS LIBRARY FUNCTION
import { Product } from "src/lib/fetcher/client";
import { formatMoney } from "src/lib/utils/formatter";
import { Wrapper } from "../styles"; // =========================================================
import { toAssetImages } from "src/lib/utils";

// =========================================================
const CartItem = (props: React.PropsWithChildren<{ product: Product; readOnly?: boolean }>) => {
  const { state, dispatch } = useCart(); // HANDLE CHANGE CART PRODUCT QUANTITY
  const qty = state.cart.find(({ product: { id } }) => id === props.product.id)?.quantity ?? 0;

  const handleCartAmountChange = (amount: number) => () => {
    dispatch({
      type: "CHANGE_CART_AMOUNT",
      payload: {
        product: props.product,
        quantity: amount,
      },
    });
  };

  return (
    <Wrapper>
      <Image
        alt={props.product.name}
        width={140}
        height={140}
        display="block"
        src={toAssetImages(props.product.imageUrl)}
      />

      {/* DELETE BUTTON */}
      {props.readOnly ? null : (
        <IconButton
          size="small"
          onClick={handleCartAmountChange(0)}
          sx={{
            position: "absolute",
            right: 15,
            top: 15,
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      )}

      <FlexBox p={2} rowGap={2} width="100%" flexDirection="column">
        <Link href={`/products/${props.product.slugName}`}>
          <Span ellipsis fontWeight="600" fontSize={18}>
            {props.product.name}
          </Span>
        </Link>

        {/* PRODUCT PRICE SECTION */}
        <FlexBox gap={1} flexWrap="wrap" alignItems="center">
          <Span color="grey.600">
            {formatMoney(props.product.salePrice)} x {qty}
          </Span>

          <Span fontWeight={600} color="primary.main">
            {formatMoney(props.product.salePrice * qty)}
          </Span>
        </FlexBox>

        {/* PRODUCT QUANTITY INC/DEC BUTTONS */}
        {props.readOnly ? null : (
          <FlexBox alignItems="center">
            <Button
              color="primary"
              sx={{
                p: "5px",
              }}
              variant="outlined"
              disabled={qty === 1}
              onClick={handleCartAmountChange(qty - 1)}
            >
              <Remove fontSize="small" />
            </Button>

            <Span mx={1} fontWeight={600} fontSize={15}>
              {qty}
            </Span>

            <Button
              color="primary"
              sx={{
                p: "5px",
              }}
              variant="outlined"
              onClick={handleCartAmountChange(qty + 1)}
            >
              <Add fontSize="small" />
            </Button>
          </FlexBox>
        )}
      </FlexBox>
    </Wrapper>
  );
};

export default CartItem;
